// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cart {
  display: flex;
  flex-direction: column;
  padding: 2em 1em;
  width: 30em;
  height: 50em;
  overflow-y: scroll;
  background-color: #f3f3f3;
  border-radius: 4px;
  position: absolute;
  top: 10%;
  right: 0;
  opacity: 0;
  animation: slideLeft 0.3s ease-in-out forwards;
}
.cart_header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.cart_header_name {
  font-family: "Varela Round";
  font-size: 1.3em;
  color: #050505;
  font-weight: bold;
}
.cart_header_total {
  font-family: "Varela Round";
  font-size: 1.2em;
  color: #050505;
}
.cart_header_view {
  font-family: "Varela Round";
  font-size: 1em;
  color: #0088ff;
  font-weight: bold;
  cursor: pointer;
}
.cart_header_checkout {
  display: flex;
  flex-direction: row;
  align-self: center;
  justify-content: center;
  align-items: center;
  font-family: "Varela Round";
  font-size: 1em;
  width: 100%;
  padding: 0.5em;
  border-radius: 4px;
  background-color: #0088ff;
  color: white;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 0.5em;
}
.cart_header_shopping {
  display: flex;
  flex-direction: row;
  align-self: center;
  justify-content: center;
  align-items: center;
  font-family: "Varela Round";
  font-size: 1em;
  width: 100%;
  text-align: center;
  border-radius: 4px;
  border: 0.5px solid #050505;
  padding: 0.5em;
  background-color: transparent;
  color: #050505;
  font-weight: bold;
  cursor: pointer;
}
.cart_items {
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(140, 140, 142, 0.4);
  width: 100%;
  margin: 1em 0;
  border-radius: 4px;
  padding: 1em;
}
.cart_items_title {
  display: flex;
  flex-direction: row;
  gap: 1em;
  padding-bottom: 0.3em;
  border-bottom: 1px solid rgba(140, 140, 142, 0.2);
}
.cart_items_title_icon {
  width: 2.5em;
  height: 2.5em;
  border: 1px solid rgba(140, 140, 142, 0.5);
  border-radius: 50%;
  padding: 0.3em;
  background-color: #050505;
}
.cart_items_title_container {
  display: flex;
  flex-direction: column;
  font-family: "Varela Round";
}
.cart_items_title_container_name {
  font-family: "Varela Round";
  font-size: 1em;
  color: #050505;
}
.cart_items_title_container_rating {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.2em;
  gap: 1em;
}
.cart_items_title_container_rating_icon_i {
  color: #ffc917;
  font-size: 0.9em;
}
.cart_items_title_container_rating_icon_ii {
  color: #4073ff;
  font-size: 0.9em;
}
.cart_items_title_container_rating_icon_num {
  color: #8c8c8e;
  margin-left: 0.3em;
  font-size: 0.9em;
}
.cart_items_item {
  display: flex;
  flex-direction: column;
  padding: 2em;
  font-family: "Varela Round";
  border-bottom: 1px solid rgba(140, 140, 142, 0.2);
}
.cart_items_item_empty {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: 1.3em;
  height: 12em;
  color: #88888a;
  font-family: "Varela Round";
}
.cart_items_item_top {
  display: flex;
  flex-direction: row;
}
.cart_items_item_top_image {
  width: 6em;
  height: 6em;
  padding: 0.3em;
  border: 1px solid rgba(140, 140, 142, 0.4);
  border-radius: 4px;
  overflow: hidden;
  margin-right: 1em;
}
.cart_items_item_top_name-container {
  display: flex;
  flex-direction: column;
  gap: 0.5em;
}
.cart_items_item_top_name-container_category {
  font-size: 0.8em;
  color: #8c8c8e;
}
.cart_items_item_top_name-container_name {
  font-size: 1em;
  color: #050505;
}
.cart_items_item_top_name-container_label {
  display: flex;
  flex-direction: row;
}
.cart_items_item_top_name-container_label_left {
  display: flex;
  flex-direction: row;
  margin-right: 1em;
  font-size: 0.85em;
}
.cart_items_item_top_name-container_label_left_name {
  color: #8c8c8e;
  margin-right: 0.3em;
}
.cart_items_item_top_name-container_label_right {
  display: flex;
  flex-direction: row;
  margin-right: 1em;
  font-size: 0.85em;
}
.cart_items_item_top_name-container_label_right_name {
  color: #8c8c8e;
  margin-right: 0.3em;
}
.cart_items_item_top_name-container_pill {
  display: flex;
  flex-direction: row;
}
.cart_items_item_top_name-container_pill_left {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 1em;
  font-size: 0.85em;
  padding: 0.2em 0.5em;
  border-radius: 4px;
  color: #38a3a5;
  background-color: rgba(128, 237, 153, 0.5);
}
.cart_items_item_top_name-container_pill_left_name {
  margin-right: 0.3em;
}
.cart_items_item_top_name-container_pill_left_value {
  font-size: 0.85em;
}
.cart_items_item_top_name-container_pill_right {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 1em;
  font-size: 0.85em;
  padding: 0.2em 0.5em;
  border-radius: 4px;
  color: #ff7b00;
  background-color: rgba(255, 170, 0, 0.5);
}
.cart_items_item_top_name-container_pill_right_name {
  margin-right: 0.3em;
  font-size: 0.85em;
}
.cart_items_item_middle {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 1em;
}
.cart_items_item_middle_q {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.cart_items_item_middle_q_delete {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 2em;
  font-size: 0.85em;
  padding: 0.2em 0.5em;
  border-radius: 4px;
  border: 1px solid rgba(140, 140, 142, 0.4);
  color: #f00000;
  background-color: transparent;
  cursor: pointer;
}
.cart_items_item_middle_q_delete:hover {
  background-color: rgba(140, 140, 142, 0.1);
}
.cart_items_item_middle_q_minus {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 1em;
  font-size: 0.85em;
  padding: 0.2em 0.5em;
  border-radius: 4px;
  border: 1px solid rgba(140, 140, 142, 0.4);
  color: #050505;
  background-color: transparent;
  cursor: pointer;
}
.cart_items_item_middle_q_minus:hover {
  background-color: rgba(140, 140, 142, 0.1);
}
.cart_items_item_middle_q_value {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 1em;
  font-size: 0.85em;
  padding: 0.2em 1.5em;
  border-radius: 4px;
  border: 1px solid rgba(140, 140, 142, 0.4);
  color: #050505;
  background-color: transparent;
}
.cart_items_item_middle_q_plus {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 1em;
  font-size: 0.85em;
  padding: 0.2em 0.5em;
  border-radius: 4px;
  border: 1px solid rgba(140, 140, 142, 0.4);
  color: #050505;
  background-color: transparent;
  cursor: pointer;
}
.cart_items_item_middle_q_plus:hover {
  background-color: rgba(140, 140, 142, 0.1);
}
.cart_items_item_middle_p {
  display: flex;
  flex-direction: column;
  align-self: flex-end;
}
.cart_items_item_middle_p_before {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 1em;
  font-size: 0.75em;
  padding: 0.2em;
  color: #88888a;
  background-color: transparent;
  text-decoration: line-through;
  align-self: flex-end;
}
.cart_items_item_middle_p_current {
  font-size: 1.3em;
  font-weight: bold;
  text-align: right;
}
.cart_items_item_middle_p_current > input {
  text-decoration: none;
  background-color: transparent;
  border: none;
  text-align: end;
  caret-color: transparent;
}
.cart_items_item_middle_p_current > input:focus {
  outline: none;
  caret-color: transparent;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@keyframes slideLeft {
  0% {
    opacity: 0;
    transform: translateX(200px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}
@media (min-width: 390px) {
  .cart {
    width: 25em;
  }
}
@media (min-width: 1280px) {
  .cart {
    width: 30em;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/cart/styles.scss","webpack://./src/assets/scss/components/_colors.scss","webpack://./src/assets/scss/components/_mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBCHU;EDIV,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,8CAAA;AADF;AAGE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AADJ;AAGI;EACE,2BAAA;EACA,gBAAA;EACA,cCtBM;EDuBN,iBAAA;AADN;AAII;EACI,2BAAA;EACA,gBAAA;EACA,cC7BI;AD2BZ;AAKI;EACE,2BAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;AAHN;AAMI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;AAJN;AAOI;EACE,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,cAAA;EACA,6BAAA;EACA,cCxEM;EDyEN,iBAAA;EACA,eAAA;AALN;AASE;EACE,aAAA;EACA,sBAAA;EACA,0CAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;AAPJ;AASI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,qBAAA;EACA,iDAAA;AAPN;AASM;EACE,YAAA;EACA,aAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,yBCpGI;AD6FZ;AAUM;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;AARR;AAUQ;EACE,2BAAA;EACA,cAAA;EACA,cC/GE;ADuGZ;AAWQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,QAAA;AATV;AAWY;EACE,cC7HH;ED8HG,gBAAA;AATd;AAYY;EACE,cAAA;EACA,gBAAA;AAVd;AAYY;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AAVd;AAiBI;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,2BAAA;EACA,iDAAA;AAfN;AAiBM;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;EACA,cCzJG;ED0JH,2BAAA;AAfR;AAkBM;EACE,aAAA;EACA,mBAAA;AAhBR;AAkBQ;EACE,UAAA;EACA,WAAA;EACA,cAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAhBV;AAmBQ;EACE,aAAA;EACA,sBAAA;EACA,UAAA;AAjBV;AAmBU;EACE,gBAAA;EACA,cAAA;AAjBZ;AAoBU;EACE,cAAA;EACA,cCxLA;ADsKZ;AAqBU;EACE,aAAA;EACA,mBAAA;AAnBZ;AAqBY;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AAnBd;AAoBc;EACE,cAAA;EACA,mBAAA;AAlBhB;AAsBY;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;AApBd;AAqBc;EACE,cAAA;EACA,mBAAA;AAnBhB;AAwBU;EACE,aAAA;EACA,mBAAA;AAtBZ;AAwBY;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,0CAAA;AAtBd;AAuBc;EACE,mBAAA;AArBhB;AAwBc;EACE,iBAAA;AAtBhB;AA0BY;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,wCAAA;AAxBd;AAyBc;EACE,mBAAA;EACA,iBAAA;AAvBhB;AA8BM;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AA5BR;AA8BQ;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AA5BV;AA8BU;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;EACA,cCxRF;EDyRE,6BAAA;EACA,eAAA;AA5BZ;AA6BY;EACE,0CAAA;AA3Bd;AA+BU;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;EACA,cCvSA;EDwSA,6BAAA;EACA,eAAA;AA7BZ;AA8BY;EACE,0CAAA;AA5Bd;AAgCU;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;EACA,cCxTA;EDyTA,6BAAA;AA9BZ;AAiCU;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,0CAAA;EACA,cCrUA;EDsUA,6BAAA;EACA,eAAA;AA/BZ;AAiCY;EACE,0CAAA;AA/Bd;AAoCQ;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;AAlCV;AAmCU;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,cCzVD;ED0VC,6BAAA;EACA,6BAAA;EACA,oBAAA;AAjCZ;AAoCU;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;AAlCZ;AAoCY;EACE,qBAAA;EACA,6BAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;AAlCd;AAqCY;EACE,aAAA;EACA,wBAAA;AAnCd;;AA4CA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAzCF;;AA4CA;EACE;IACE,UAAA;IACA,4BAAA;EAzCF;EA4CA;IACE,UAAA;IACA,wBAAA;EA1CF;AACF;AEzVE;EFuYA;IACE,WAAA;EA3CF;AACF;AE5UE;EF2XA;IACE,WAAA;EA5CF;AACF","sourcesContent":["@import \"../../assets//scss/combined.scss\";\n\n.cart {\n  display: flex;\n  flex-direction: column;\n  padding: 2em 1em;\n  width: 30em;\n  height: 50em;\n  overflow-y: scroll;\n  background-color: $bdt-white;\n  border-radius: 4px;\n  position: absolute;\n  top: 10%;\n  right: 0;\n  opacity: 0;\n  animation: slideLeft 0.3s ease-in-out forwards;\n\n  &_header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n\n    &_name {\n      font-family: \"Varela Round\";\n      font-size: 1.3em;\n      color: $bdt-black;\n      font-weight: bold;\n    }\n\n    &_total {\n        font-family: \"Varela Round\";\n        font-size: 1.2em;\n        color: $bdt-black;\n      }\n\n    &_view {\n      font-family: \"Varela Round\";\n      font-size: 1em;\n      color: #0088ff;\n      font-weight: bold;\n      cursor: pointer;\n    }\n\n    &_checkout {\n      display: flex;\n      flex-direction: row;\n      align-self: center;\n      justify-content: center;\n      align-items: center;\n      font-family: \"Varela Round\";\n      font-size: 1em;\n      width: 100%;\n      padding: 0.5em;\n      border-radius: 4px;\n      background-color: #0088ff;\n      color: white;\n      font-weight: bold;\n      cursor: pointer;\n      margin-bottom: .5em;\n    }\n\n    &_shopping {\n      display: flex;\n      flex-direction: row;\n      align-self: center;\n      justify-content: center;\n      align-items: center;\n      font-family: \"Varela Round\";\n      font-size: 1em;\n      width: 100%;\n      text-align: center;\n      border-radius: 4px;\n      border: .5px solid $bdt-black;\n      padding: 0.5em;\n      background-color: transparent;\n      color: $bdt-black;\n      font-weight: bold;\n      cursor: pointer;\n    }\n  }\n\n  &_items {\n    display: flex;\n    flex-direction: column;\n    border: 1px solid rgba(140, 140, 142, 0.4);\n    width: 100%;\n    margin: 1em 0;\n    border-radius: 4px;\n    padding: 1em;\n\n    &_title {\n      display: flex;\n      flex-direction: row;\n      gap: 1em;\n      padding-bottom: 0.3em;\n      border-bottom: 1px solid rgba(140, 140, 142, 0.2);\n\n      &_icon {\n        width: 2.5em;\n        height: 2.5em;\n        border: 1px solid rgba(140, 140, 142, 0.5);\n        border-radius: 50%;\n        padding: 0.3em;\n        background-color: $bdt-black;\n      }\n\n      &_container {\n        display: flex;\n        flex-direction: column;\n        font-family: \"Varela Round\";\n\n        &_name {\n          font-family: \"Varela Round\";\n          font-size: 1em;\n          color: $bdt-black;\n        }\n\n        &_rating {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          padding: 0.2em;\n          gap: 1em;\n          &_icon {\n            &_i {\n              color: $bdt-gold;\n              font-size: 0.9em;\n            }\n\n            &_ii {\n              color: #4073ff;\n              font-size: 0.9em;\n            }\n            &_num {\n              color: #8c8c8e;\n              margin-left: 0.3em;\n              font-size: 0.9em;\n            }\n          }\n        }\n      }\n    }\n\n    &_item {\n      display: flex;\n      flex-direction: column;\n      padding: 2em;\n      font-family: \"Varela Round\";\n      border-bottom: 1px solid rgba(140, 140, 142, 0.2);\n\n      &_empty {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: center;\n        font-size: 1.3em;\n        height: 12em;\n        color: $bdt-gray;\n        font-family: \"Varela Round\";\n      }\n\n      &_top {\n        display: flex;\n        flex-direction: row;\n\n        &_image {\n          width: 6em;\n          height: 6em;\n          padding: 0.3em;\n          border: 1px solid rgba(140, 140, 142, 0.4);\n          border-radius: 4px;\n          overflow: hidden;\n          margin-right: 1em;\n        }\n\n        &_name-container {\n          display: flex;\n          flex-direction: column;\n          gap: 0.5em;\n\n          &_category {\n            font-size: 0.8em;\n            color: #8c8c8e;\n          }\n\n          &_name {\n            font-size: 1em;\n            color: $bdt-black;\n          }\n\n          &_label {\n            display: flex;\n            flex-direction: row;\n\n            &_left {\n              display: flex;\n              flex-direction: row;\n              margin-right: 1em;\n              font-size: 0.85em;\n              &_name {\n                color: #8c8c8e;\n                margin-right: 0.3em;\n              }\n            }\n\n            &_right {\n              display: flex;\n              flex-direction: row;\n              margin-right: 1em;\n              font-size: 0.85em;\n              &_name {\n                color: #8c8c8e;\n                margin-right: 0.3em;\n              }\n            }\n          }\n\n          &_pill {\n            display: flex;\n            flex-direction: row;\n\n            &_left {\n              display: flex;\n              flex-direction: row;\n              align-items: center;\n              margin-right: 1em;\n              font-size: 0.85em;\n              padding: 0.2em 0.5em;\n              border-radius: 4px;\n              color: #38a3a5;\n              background-color: rgba(128, 237, 153, 0.5);\n              &_name {\n                margin-right: 0.3em;\n              }\n\n              &_value {\n                font-size: 0.85em;\n              }\n            }\n\n            &_right {\n              display: flex;\n              flex-direction: row;\n              align-items: center;\n              margin-right: 1em;\n              font-size: 0.85em;\n              padding: 0.2em 0.5em;\n              border-radius: 4px;\n              color: #ff7b00;\n              background-color: rgba(255, 170, 0, 0.5);\n              &_name {\n                margin-right: 0.3em;\n                font-size: 0.85em;\n              }\n            }\n          }\n        }\n      }\n\n      &_middle {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        justify-content: center;\n        margin: 1em;\n\n        &_q {\n          display: flex;\n          flex-direction: row;\n          align-items: center;\n          justify-content: center;\n\n          &_delete {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            margin-right: 2em;\n            font-size: 0.85em;\n            padding: 0.2em 0.5em;\n            border-radius: 4px;\n            border: 1px solid rgba(140, 140, 142, 0.4);\n            color: $bdt-red;\n            background-color: transparent;\n            cursor: pointer;\n            &:hover {\n              background-color: rgba(140, 140, 142, 0.1);\n            }\n          }\n\n          &_minus {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            margin-right: 1em;\n            font-size: 0.85em;\n            padding: 0.2em 0.5em;\n            border-radius: 4px;\n            border: 1px solid rgba(140, 140, 142, 0.4);\n            color: $bdt-black;\n            background-color: transparent;\n            cursor: pointer;\n            &:hover {\n              background-color: rgba(140, 140, 142, 0.1);\n            }\n          }\n\n          &_value {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            margin-right: 1em;\n            font-size: 0.85em;\n            padding: 0.2em 1.5em;\n            border-radius: 4px;\n            border: 1px solid rgba(140, 140, 142, 0.4);\n            color: $bdt-black;\n            background-color: transparent;\n          }\n\n          &_plus {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            margin-right: 1em;\n            font-size: 0.85em;\n            padding: 0.2em 0.5em;\n            border-radius: 4px;\n            border: 1px solid rgba(140, 140, 142, 0.4);\n            color: $bdt-black;\n            background-color: transparent;\n            cursor: pointer;\n\n            &:hover {\n              background-color: rgba(140, 140, 142, 0.1);\n            }\n          }\n        }\n\n        &_p {\n          display: flex;\n          flex-direction: column;\n          align-self: flex-end;\n          &_before {\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            margin-right: 1em;\n            font-size: 0.75em;\n            padding: 0.2em;\n            color: $bdt-gray;\n            background-color: transparent;\n            text-decoration: line-through;\n            align-self: flex-end;\n          }\n\n          &_current {\n            font-size: 1.3em;\n            font-weight: bold;\n            text-align: right;\n\n            & > input {\n              text-decoration: none;\n              background-color: transparent;\n              border: none;\n              text-align: end;\n              caret-color: transparent;\n            }\n\n            & > input:focus {\n              outline: none;\n              caret-color: transparent;\n            }\n          }\n        }\n      }\n    }\n  }\n}\n\nimg {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n@keyframes slideLeft {\n  0% {\n    opacity: 0;\n    transform: translateX(200px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@include screen-sm {\n  .cart {\n    width: 25em;\n  }\n}\n\n@include screen-xl {\n  .cart {\n    width: 30em;\n  }\n}\n","$bdt-yellow-gold: #ffe100;\n$bdt-gold: #ffc917;\n$bdt-red: #f00000;\n$bdt-dark-red: #8c0000;\n$bdt-black: #050505;\n$bdt-gray: #88888a;\n$bdt-white: #f3f3f3;\n$bdt-green: #37ff8b;\n\n","$screen-sm: 390px;\n$screen-md: 768px;\n$screen-lg: 1024px;\n$screen-xl: 1280px;\n$screen-2xl: 1640px;\n$screen-3xl: 1920px;\n\n@mixin screen-sm {\n  @media (min-width: $screen-sm) {\n    @content;\n  }\n}\n\n@mixin screen-md {\n  @media (min-width: $screen-md) {\n    @content;\n  }\n}\n\n@mixin screen-lg {\n  @media (min-width: $screen-lg) {\n    @content;\n  }\n}\n\n@mixin screen-xl {\n  @media (min-width: $screen-xl) {\n    @content;\n  }\n}\n\n@mixin screen-2xl {\n  @media (min-width: $screen-2xl) {\n    @content;\n  }\n}\n\n@mixin screen-3xl {\n  @media (min-width: $screen-3xl) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
